import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2362134b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2362134b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362134b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2362134b')) {
      api.createRecord('2362134b', component.options)
    } else {
      api.reload('2362134b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2362134b&scoped=true&", function () {
      api.rerender('2362134b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabAvatar/index.vue"
export default component.exports